import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, queryParameters } from "../module_auth/AuthService"
import { PaginationCustom } from "../component/common/PaginationCustom"
import { useNavigate } from "react-router-dom"
import { NoticeTableRow } from './NoticeTableRow';
import { isValidSearchPage } from './common/BaseUtil';
import './Notice.css'
import { useLocation } from "react-router-dom";
import { sendGoogleAnalytics } from "./common/BaseUtil"

export function NoticeList() {
    const location = useLocation();

    const [noticeList, setNoticeList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    const navigate = useNavigate();
    ////pagination

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        loadEntity()
    }, []);

    function loadEntity(){
        
        //currentPage
        let currentPage
        if(!isValidSearchPage(page)){
            let localStoragePage = localStorage.getItem("page")
            currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
        } else {
            currentPage = page == "0" ? "1" : page
        }
        //end currentPage
        
        navigate("/notice_list?page="  + currentPage);
        localStorage.setItem("page", currentPage)
        let url = basePort + '/get/notices/' + currentPage
        let activePageIndex = (currentPage-1)%2
        if(next != null){
            url = basePort + '/get/notices/next/' + currentPage
            activePageIndex = (currentPage-1)%2
        } else if(previous != null) {
            url = basePort + '/get/notices/previous/' + currentPage
            activePageIndex = (currentPage-1)%2
        }
        
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
            setNoticeList(response.cardList)
            
            ////pagination
            setPageList(response.displayPages)
            setLastPage(response.lastPage)
            setActivePageIndex(activePageIndex)
            ////pagination

          }).catch(error => console.log(error))
    }

    function onClick(id) {
        //let objectId = object.id.toString()
        let url = "/notice?id=" + id;
        navigate(url);
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>공지사항</span></li>
                        </ol>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>제목</th>
                                        <th className="responsive-notice" style={{width: '150px'}}>등록일</th>
                                        <th className="responsive-notice" style={{width: '100px'}}>조회</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {noticeList.map((object, index) => (
                                        <NoticeTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <PaginationCustom 
                        lastPage={lastPage}
                        page={page}
                        pageList={pageList}
                        activePageIndex={activePageIndex}
                        url={'notice_list'}
                    />
                </section>
            </main>
        </div>
    );
}